<template>
  <div class="item-base">
    <div class="itembody">
      <h4 v-if="showTitle" v-html="menuTitle"></h4>
      <template v-if="hasTags">
        <div class="menu-tags" v-if="tags.length > 0">
          <span class="tag-icon"><img src="/static/img/icons/ic_tag.svg"></span>
          <!-- <tag-list :tag-list="tags" :link-enable="textMenuOpenTrigger && !forceDisableTagLink" />-->
          <tag-list :tag-list="tags" :link-enable="false" />
        </div>
      </template>
      <div class="description" :class="{ hasCounselorData: hasCounselorData, hasTarot: hasTarotImg}">
        <span class="counselor-img" v-if="hasCounselorData" :class="{nophoto: isCThumbError}">
          <img :src="counselorImg" :alt="counselorName" @load="onCThumbLoad" @error="onCThumbError" />
        </span>
        <span class="description-body" v-html="description"></span>
      </div>
    </div>
  </div>
</template>

<script>
import TagList from "@/utvStore/components/partials/TagList";
import ItemHeading from "@/utvStore/components/partials/ItemHeading";
import LinkIcon from "@/utvStore/components/partials/LinkIcon";
import FavButton from '@/utvStore/components/partials/FavButton'
import { MENU_SEC_TYPES, SEC_ICON_TYPE, MENU_ITEM_TYPE } from '@/CONSTS/MENUS'
import {mapState} from 'vuex'
import * as type from "@/utvStore/store/mutation-types";
export default {
  name: "ResultList",
  components: {LinkIcon, ItemHeading, TagList, FavButton},
  data(){
    return {
      isCThumbError: false,
      itemDataMod: {},
      favNum: 0,
      favStatus: false
    }
  },
  props: {
    showTitle: {
      type: Boolean,
      default: false,
    },
    noFav: {
      type: Boolean,
      default: false,
    },
    forceDisableTagLink: {
      type: Boolean,
      default: false,
    },
    allLock: {
      type: Boolean,
      default: false,
    },
    itemData: {
      type: Object,
      default() {
        return {}
      }
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    scrollClass: {
      type: String,
      default: '.list-body'
    },
    scrollTgtIsWindow: {
      type: Boolean,
      default: false,
    }

  },
  watch: {
    itemData: {
      handler(val){
        this.setItemData()
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      accessToken: states => states.auth.accessToken
    }),
    isCounselor() {
      return !!this.itemDataMod.counselor && !!this.itemDataMod.counselor.id
    },
    hasCounselorData() {
      return !!this.itemDataMod.counselor && this.itemDataMod.itemType === MENU_ITEM_TYPE.text
    },
    counselorImg() {
      if(!!this.itemDataMod.counselor && !!this.itemDataMod.counselor.thumbnail){
        return this.itemDataMod.counselor.thumbnail
      }else{
        return ''
      }
    },
    counselorName() {
      if(!!this.itemDataMod.counselor && !!this.itemDataMod.counselor.name){
        return this.itemDataMod.counselor.name
      }else{
        return ''
      }
    },
    hasTags(){
      return this.itemDataMod ? !!this.itemDataMod.tags : false
    },
    menuTitle(){
      return !!this.itemDataMod.result ? !!this.itemDataMod.result.title ? this.itemDataMod.result.title : '' : ''
    },
    description() {
      return !!this.itemDataMod.result ? !!this.itemDataMod.result.text ? this.itemDataMod.result.text : '' : ''
    },
    hasTarotImg(){
      return /class=\"tarot-img\"/.test(this.description)
    },
    tags() {
      const rtn = []
      if(!!this.itemDataMod && !!this.itemDataMod.tags ){
        this.itemDataMod.tags.forEach(val=>{
          if(!/^_/.test(val.tagName)){
            rtn.push({ ...val, label: val.tagName })
          }
        })
      }
      return rtn
    }
  },
  created() {
    this.setItemData()
  },
  methods: {
    setItemData (){
      this.favNum = this.itemData.localFavNum
      this.favStatus = this.itemData.localFavStat
      this.itemDataMod = this.itemData
    },
    onCThumbError(e){
      this.isCThumbError = true
    },
    onCThumbLoad(e){},
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.item-base {
  width: 100%;
  min-height: 80px;
  padding: 25px 20px;
  border-bottom: 1px solid $col_temp_gray3;
  position: relative;
  color: $col_dark_font;
  .itembody {
    .thumbnail {
      $largeSize: 85px;
      width: $largeSize;
      height: $largeSize;
      border-radius: $largeSize / 2;
      margin-right: 16px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
  }
  .itemfoot {
    text-align: right;
    line-height: 1;
    padding: 15px 0 0;
    margin-right: -6px;
    display: flex;
    justify-content: space-between;
    /deep/ .fav-btn-base {
      margin-top: 2px;
      &.nofav {
        visibility: hidden;
      }
      & > span {
        display: inline-block;
        line-height: 0.7;
      }
      svg {
        width: 17px;
      }
      .fav-num {
        font-size: 11px;
        margin-left: 4px;
      }
    }
  }
}

.nophoto {
  line-height: 1;
  font-size: 11px;
  color: $col_temp_key1;
  background: $col_lite_gradient;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-tags {
  display: block;
  padding-left: 18px;
  position: relative;
  margin-bottom: 14px;
  .tag-icon {
    display: inline-block;
    position: absolute;
    top: 3px;
    left: 0;
    width: 13px;
    img {
      display: block;
      width: 100%;
    }
  }
}

h4 {
  margin: 0 0 10px;
  font-size: 20px;
}

.description {
  font-weight: normal;
  font-size: 13px;
  line-height: 21px;
  color: $col_normal_font;
  overflow: hidden;
  position: relative;
  .counselor-img {
    display: none;
  }
  &.hasCounselorData {
    //padding-left: calc(55px + 12px);
    min-height: 60px;
    .counselor-img {
      width: 55px;
      height: 55px;
      display: block;
      overflow: hidden;
      border-radius: 30px;
      float: left;
      margin-right: 12px;
      //position: absolute;
      //top: 4px;
      //left: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.nophoto {
        img{
          display: none;
        }
        &::after {
          content: 'NO IMAGE';
          width: 100%;
          height: 100%;
          line-height: 1;
          transform: scale(0.8);
          font-size: 10px;
          color: $col_temp_key1;
          background: $col_lite_gradient;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  &.hasTarot {
    .counselor-img {
      float: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/ResultList.vue